const STORAGE_KEY = "pl-widget-changelog-allowed"

// The widget boots before the trial query resolves, so the last known answer
// gates the first load. Unknown means suppress: a fresh signup must not get a
// changelog popped at them mid-onboarding.
export function isChangelogNotificationAllowed(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === "true"
	} catch {
		return false
	}
}

export function setChangelogNotificationAllowed(allowed: boolean): void {
	try {
		if (allowed) {
			localStorage.setItem(STORAGE_KEY, "true")
		} else {
			localStorage.removeItem(STORAGE_KEY)
		}
	} catch {
		// Safari private mode can throw on write.
	}
}
